export default __webpack_public_path__ + "56b50a56fc9961e02fc9df04a68d6ce3.png";